import { resolvePolymorphVar } from "@green24/npm-javascript-utils";

export class StateHandler {
	constructor({initialState, defaultInitialState}) {
		this.state = null;
		this.initialState = resolvePolymorphVar(
			initialState,
			{
				function: f => f(defaultInitialState),
				object: o => ({
					...defaultInitialState,
					...o,
				})
			},
			() => initialState,
			true
		);

		this.setState(this.initialState);
	}

	/**
	 * Set state
	 * ---
	 * @param {Object} state
	 */
	setState(state) {
		if(state === undefined) return this.initialState;

		this.state = state;
	}

	/**
	 * @abstract
	 * Handle action
	 * ---
	 * @param {Object} action
	 */
	handleAction(action) {
		return this.state;
	}
}
